<template>
    <div>
        <div class="info-box">
            <div class="info-title">
                <h3>基础信息</h3>
                <p></p>
            </div>
            <div class="info-main">      
                <div class="input-box">
                    <p>组织学院：</p>
                    <a-select class="input" allowClear v-model="info.organizedDepartmentCode" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in xyArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>参赛学院：</p>
                    <a-select class="input" allowClear v-model="info.participateDepartmentCode" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in xyArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>竞赛全称：</p>
                    <a-input class="input" v-model="info.competitionName" :disabled="type=='look'" />
                </div>
                <div class="input-box">
                    <p>竞赛主办方：</p>
                    <a-input class="input" v-model="info.sponsor" :disabled="type=='look'" />
                </div>
                <div class="input-box">
                    <p>举办日期：</p>
                    <a-date-picker class="input" v-model="info.holdDate" @change="(date, dateString)=>{info.holdDate=dateString}" :disabled="type=='look'"/>
                </div>
                <div class="input-box">
                    <p>竞赛项目/组别：</p>
                    <a-input class="input" v-model="info.competeEventGroup" :disabled="type=='look'" />
                </div>
                <div class="input-box">
                    <p>指导教师/工号：</p>
                    <a-select 
                        class="input" 
                        allowClear
                        show-search
                        :filter-option="false"
                        @search="teacherSearch"
                        v-model="info.guideTeacherNo"
                        @change="teacherChange"
                        option-label-prop="label"
                        :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in jsArr" :key="index" :value="item.teacherId" :label="item.teacherName">{{item.teacherId}}-{{item.teacherName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>奖项名称：</p>
                    <a-input class="input" v-model="info.awardName" :disabled="type=='look'" />
                </div>
                <div class="input-box">
                    <p>获奖等级：</p>
                    <a-select class="input" allowClear v-model="info.awardLevelCode" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in hjdjArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>奖项类型：</p>
                    <a-select class="input" allowClear v-model="info.awardTypeCode" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in hjlxArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box input-box-center">
                    <p>学生所在学院：</p>
                    <a-select class="input" allowClear v-model="info.studentsDepartment" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in xyArr" :key="index" :value="item.dataName">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box input-box-half">
                    <p>学生姓名/学号：</p>
                    <a-textarea :rows="4"  class="input" v-model="info.studentsName"/>
                </div>
                <div class="input-box input-box-half">
                    <p>备注：</p>
                    <a-textarea :rows="4"  class="input" v-model="info.remark"/>
                </div>
            </div>
        </div>
        <div class="info-box">
            <div class="info-title">
                <h3>证书扫描件</h3>
                <p></p>
            </div>
            <a-upload-dragger
                class="upload-box"
                name="file"
                list-type="picture-card"
                :multiple="true"
                :action="$store.state.axiosUrl+'/api-f/files'"
                :headers="headers"
                @change="fileChange"
                :file-list="fileList"
                :disabled="type=='look'"
            >
                <p class="ant-upload-drag-icon">
                    <a-icon type="inbox" />
                </p>
                <p class="ant-upload-text">点击或拖拽文件上传</p>
                <p class="ant-upload-hint">支持单次或批量上传</p>
            </a-upload-dragger>
        </div>
        <div class="btn-box">
            <a-button type="primary" v-if="type!='look'" @click="sub">提交</a-button>
            <a-button @click="$router.go(-1)">取消</a-button>
        </div>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { add,update,info } from '@/baseAPI/undergraduate/student/subject'
    import { getTeacher } from '@/baseAPI/facultyTeacher'
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                type:'',
                info:{
                    organizedDepartmentCode:null,
                    participateDepartmentCode:null,
                    competitionName:null,
                    sponsor:null,
                    holdDate:null,
                    competeEventGroup:null,
                    guideTeacherNo:null,
                    guideTeacherName:null,
                    awardName:null,
                    awardLevelCode:null,
                    awardTypeCode:null,
                    studentsDepartment:null,
                    studentsName:null,
                    remark:null,
                    fileList:[],
                },
                jsArr:[],
                xyArr:[],
                hjdjArr:[],
                hjlxArr:[],
                headers:{
                    'Authorization':'Bearer '+ this.$store.state.access_token
                },
                fileList:[],

            }
        },
        mounted () {
            getDicts({dataCode:'XY',status:true}).then(res=>{
                this.xyArr=res.data.dicts;
                this.info.organizedDepartmentCode=res.data.defaultValue[0]
                this.info.participateDepartmentCode=res.data.defaultValue[0]
            })
            getDicts({dataCode:'XKJS_HJDJ',status:true}).then(res=>{
                this.hjdjArr=res.data.dicts;
                this.info.awardLevelCode=res.data.defaultValue[0]
            })
            getDicts({dataCode:'XKJS_HJLX',status:true}).then(res=>{
                this.hjlxArr=res.data.dicts;
                this.info.awardTypeCode=res.data.defaultValue[0]
            })
            this.type=this.$route.query.type;
            if(this.type!='add'){
                info(this.$route.query.id).then(res=>{
                    this.info=res.data;
                    this.fileList=[];
                    for(let i=0;i<this.info.fileList.length;i++){
                        this.fileList.push({
                            uid: this.info.fileList[i].id,
                            name: this.info.fileList[i].fileName,
                            status: 'done',
                            url: this.$store.state.axiosUrl+this.info.fileList[i].fileUrl,
                        })
                    }
                })
            }
        },
        methods:{
            teacherSearch(value){
                getTeacher({teacherName:value}).then(res=>{
                    this.jsArr=res.data;
                })
            },
            teacherChange(value){
                for(let i=0;i<this.jsArr.length;i++){
                    if(this.jsArr[i].teacherId==value){
                        this.info.guideTeacherName=this.jsArr[i].teacherName
                    }
                }
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            fileChange(file){
                if(typeof file.file.response!='undefined'){
                    var res=file.file.response;
                    this.$notification['success']({
                        message: '成功',
                        description:'文件上传成功'
                    });
                    this.info.fileList.push({
                        fileName:res.name,
                        fileUrl:res.url
                    })
                }else if(file.file.status=='removed'){
                    var num=this.fileList.indexOf(file.file);
                    this.info.fileList.splice(num, 1)
                }
                this.fileList=file.fileList;
            },
            sub(){
                var isSub=true;
                var arr=['remark','approvalStatus','semesterCode']
                for(let key in this.info){
                    if(arr.indexOf(key)<0){
                        if(this.info[key]==null||this.info[key]===''){
                            isSub=false;
                            break;
                        }
                    }
                }
                if(isSub){
                    if(this.type=='add'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增学科竞赛成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改学科竞赛成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            },
        }
    }
</script>
<style scoped>
    .info-box{
        margin-bottom: 2rem;
    }
    .info-title{
        position: relative;
        line-height: 3rem;
    }
    .info-title h3{
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        padding-left: 10px;
        color: #245086;
    }
    .info-title p{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50%;
        height: 3px;
        background-image: linear-gradient(to right, #245086 , rgba(36,80,134,0));
    }
    .info-title .ant-btn{
        float: right;
        margin-top: calc(1.5rem - 16px);
        margin-right: 2rem;
    }
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }
    .info-main .input-box{
        width: 33%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
    }
    .info-main .input-box-center{
        width: 66%;
    }
    .info-main .input-box-half{
        width: 49.5%;
    }
    .info-main .input-box p{
        width: 10rem;
        text-align: right;
    }
    .info-main .input-box .input{
        width: calc(100% - 12rem);
    }
    .ant-table-wrapper{
        margin-top: 2rem;
    }
    .ant-table-wrapper >>> .ant-empty-normal{
        display: none;
    }
    .text-box{
        display: flex;
        margin-bottom: 0.5rem;
    }
    .text-box p{
        font-size: 1rem;
        line-height: 2rem;
    }
    .text-box .title{
        width: 5rem;
        text-align: right;
    }
    .text-box .text{
        border: 1px solid #ccc;
        padding: 0 10px;
        border-radius: 5px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 10px;
    }
    .ant-table-wrapper .input-box{
        width: 100%;
    }
    .btn-box{
        text-align: center;
        padding-bottom: 1rem;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    .upload-box{
        margin-top: 2rem;
        display: block;
    }
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled,.ant-calendar-picker >>> .ant-input[disabled]{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }
    .upload-box >>> .ant-upload-list:after{
      content: ".";
      display: block;
      font-size: 0;
      height: 0;
      clear: both;
    }
    .upload-box >>> .ant-upload.ant-upload-disabled{
        display: none;
    }

</style>
